<template>
  <div class="payment-method-item">
    <div v-if="card.account_type === 'credit_card'">
      <img
        style="width: 28px; margin-right: 5px"
        :alt="card.card_type"
        :src="
          // eslint-disable-next-line
          '/build/img/' + card.card_type.toLowerCase().replace(/ /g, '_') + '.png'
        "
      />
    </div>
    <div
      v-else-if="
        ['bank_acct', 'ach_credit_transfer'].includes(card.account_type)
      "
    >
      <i class="fa fa-university" style="margin-right: 5px"></i>
    </div>
    <div v-else>
      <i class="fa fa-cloud" style="margin-right: 5px"></i>
    </div>
    <div>
      <b>{{ card.card_type }}</b>
      <small
        v-if="
          card.account_type !== 'ach_credit_transfer' &&
          card.account_type !== 'bank_transfer'
        "
      >
        ending in {{ maskedNumber(card) }}
      </small>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    card: {
      type: Object,
      required: true,
    },
  },
  methods: {
    maskedNumber(card) {
      const val = card.masked_number;
      return val.substring(val.length - 4);
    },
  },
};
</script>

<style scoped>
.payment-method-item {
  display: flex;
  flex-direction: row;
  margin-bottom: 1rem;
}
</style>
